<template>
  <b-container fluid class="theme-yellow">
    <div class="page-header">
      <Navbar text="Web AR" />
    </div>

    <section>
      <h2>What is Harpra Web AR?</h2>

      <p>
        Harpra Web AR is the tool to deploy your models directly to your website
        using Immersive Embeds giving your viewers the ability to enjoy
        an interactive experience.
      </p>

      <h2>Get Started</h2>

      <b-button variant="primary" :to="{ name: 'WebARModels', query: { add: true } }" class="mr-3">
        Upload Models
      </b-button>

      <b-button variant="primary" :to="{ name: 'WebAREmbeds', query: { add: true } }" class="mr-3">
        Create Embed
      </b-button>
    </section>
    <section>
      <h2>Resources</h2>

      <div class="resources">
        <b-embed
          type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/FBz7em0blws"
          allowfullscreen
        ></b-embed>

        <b-embed
          type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/z0wPduBwBo8"
          allowfullscreen
        ></b-embed>
      </div>
    </section>
  </b-container>
</template>

<script>
import Navbar from "@/components/Navigation/Navbar";
import * as routerUtils from "@/utils/router-utils";
import { mapGetters } from "vuex";

export default {
  name: "WebAR",
  data() {
    return {
      subscriptionActive: false,
    };
  },
  components: {
    Navbar,
  },
  computed: {
    ...mapGetters([ "isActive" ])
  },
  created() {
    if (!this.isActive) {
      routerUtils.routeToAccount(this);
    }
  },
};
</script>
